// extracted by mini-css-extract-plugin
module.exports = {"patternContent":"GridBackground_patternContent__1lY8-","pattern":"GridBackground_pattern__25Cm4","gradient":"GridBackground_gradient__2HUFA"};